import React from "react";
import { Navigate } from "react-router-dom";

export default function PlatformRoute({ me, authChecked, children }) {
  if (!authChecked) {
    return <div style={{ padding: 24, color: "white" }}>Loading...</div>;
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  if (!me.is_platform_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
